import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Data } from "@angular/router";

@Pipe({
  name: "safeUrl",
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeUrl {
    if (!url){
    return this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    const modifiedUrl: Data = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return modifiedUrl.changingThisBreaksApplicationSecurity
      ? modifiedUrl.changingThisBreaksApplicationSecurity
      : modifiedUrl;
  }
}
